export const formatPremium = (value: number, currency: string, locale = `en`): string => {
  const formatter = new Intl.NumberFormat(locale, { style: `currency`, currency })
  return formatter.format(value / 100)
}
